import { FC } from 'react';
import { Agent } from 'src/types/agents.ts';
import { UIAccordion } from 'src/components/UI/UIAccordion.tsx';
import { shortenHash } from 'src/utils/ui.ts';
import { Icon } from '@iconify/react';
import { BN } from 'src/utils/bigNumber.ts';

interface HolderDistributionProps {
  agent: Agent;
}

export const HolderDistribution: FC<HolderDistributionProps> = ({ agent }) => {
  return (
    <UIAccordion
      items={[
        {
          opened: true,
          title: 'Holder Distribution',
          content: (
            <div className="flex flex-col gap-3 px-6 pb-6">
              {agent.token_info?.top_holders?.map((holder, i) => (
                <div key={i} className="flex justify-between">
                  <a
                    href={`https://basescan.org/address/${holder.address}`}
                    target="_blank"
                    rel="noreferrer"
                    className="group"
                  >
                    <div className="flex items-center">
                      <span className="inline-block w-6">{i + 1}.</span>
                      <span className="w-24 group-hover:underline">
                        {shortenHash(holder.address)}
                      </span>

                      <Icon icon="material-symbols:open-in-new-rounded" />
                    </div>
                  </a>
                  <span>
                    {BN(holder.balance)
                      .div(BN(agent.token_info?.supply).times(1e18))
                      .times(100)
                      .toFixed(2)}
                    %
                  </span>
                </div>
              ))}
            </div>
          ),
        },
      ]}
    />
  );
};
